<template>
    <div>
        <br />
        <h2>Local Risk Control</h2>
        <b-row><b-col><b-card border-variant="danger" v-if="ActiveProfile == false" align="center">
            <b-row><b-col>You do not currently have a Risk Control Profile Set for this location.</b-col></b-row>
             <b-row><b-col>The default values below will be used for Alerts and Notification</b-col></b-row>
            <b-row><b-col> You can create a custom Risk Profile using the button at the bottom of the page.</b-col></b-row>
            </b-card></b-col></b-row>
        <b-row><b-col>Current Risk Control Values</b-col>
        <b-col><b-badge pill variant="info"  
            v-b-tooltip.hover title="Risk Control Values are used to provide notifications and alerts based on the parameters provided">i</b-badge></b-col></b-row>
  
        <hr/>
            <b-row><b-col>
                 <b-card align="center">
                    <b-row><b-col align="left"><b>Created By</b></b-col>
                    <b-col>{{ this.RiskProfile.General.CreatedBy }}</b-col>
                    <b-col align="left"><b>Created On</b></b-col>
                    <b-col>{{ this.RiskProfile.General.CreatedOn }}</b-col></b-row>
                    <b-row><b-col align="left"><b>Location</b></b-col>
                    <b-col>{{this.selectedlocation}}</b-col>
                    <b-col align="left"><b>Responsible Dept</b></b-col>
                    <b-col>{{this.RiskProfile.General.ResponsibleDept}}</b-col></b-row>
                    <br/>
                
                    </b-card>
                </b-col></b-row>
            <b-row><b-col><b-card-group deck>
                <b-card header="Hot Water"
                    class="text-center"
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light"
                    v-if="HotVisible == true">
                    <b-row><b-col align="left"><b>Outlet Minimum</b></b-col>
                        <b-col align="right">{{this.RiskProfile.HotWater.OutletMin}}&deg;C</b-col></b-row>
                    <b-row><b-col align="left"><b>Hot Water Return</b></b-col>
                        <b-col align="right">{{this.RiskProfile.HotWater.HotWaterReturn}}&deg;C</b-col></b-row></b-card>
                <b-card header="Cold Water" 
                    class="text-center"
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light"
                    v-if="ColdVisible == true">
                    <b-row><b-col align="left"><b>Outlet Maximum</b></b-col>
                        <b-col align="right">{{this.RiskProfile.ColdWater.OutletMax}}&deg;C</b-col></b-row>
                    <b-row><b-col align="left"><b>Incoming Supply Temp</b></b-col>
                        <b-col align="right">{{this.RiskProfile.ColdWater.SupplyTemp}}&deg;C</b-col></b-row></b-card>
            </b-card-group></b-col></b-row>
            <b-row><b-col>
            <b-card-group deck>
                <b-card header="Flow" 
                    class="text-center"
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light"
                    v-if="FlowVisible == true">
                    <b-row><b-col align="left" cols="5"><b>Outlet Flow Frequency</b></b-col><b-col><b-badge pill variant="info"  
            v-b-tooltip.hover title="Acceptable length of time between recorded flow events on the outlet">i</b-badge></b-col>
  
                    <b-col align="right">{{this.RiskProfile.Flow.OutletFrequency}}hrs</b-col></b-row></b-card>
                <b-card header="TMV" 
                    class="text-center"
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light"
                    v-if="TMVVisible == true">
                    <b-row><b-col align="left"><b>Hot In</b></b-col>
                        <b-col align="right">{{this.RiskProfile.TMV.TMVHot}}&deg;C</b-col></b-row>
                    <b-row><b-col align="left"><b>Cold In</b></b-col>
                        <b-col align="right">{{this.RiskProfile.TMV.TMVCold}}&deg;C</b-col></b-row>
                    <b-row><b-col align="left"><b>Mixed Out Max</b></b-col>
                        <b-col align="right">{{this.RiskProfile.TMV.MixedOut}}&deg;C</b-col></b-row></b-card>
            </b-card-group>
            </b-col>
            </b-row>
            <b-row><b-col>
            <b-card-group deck>
                <b-card header="Tanks & Heaters" 
                    class="text-center"
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light"
                    v-if="TanksVisible == true">
                    <b-row><b-col align="left"><b>C/Water Storage</b></b-col>
                    <b-col align="right">Max Value {{this.RiskProfile.Tanks.ColdWaterMax}}&deg;C</b-col>
                    </b-row>
                    <b-row><b-col align="left"><b>H/Water Storage</b></b-col>
                        <b-col align="left">Min Value {{this.RiskProfile.Tanks.HotWaterMin}}&deg;C</b-col>
                        <b-col align="right">Max Value {{this.RiskProfile.Tanks.HotWaterMax}}&deg;C</b-col>      
                    </b-row>
                    <b-row><b-col align="left"><b>Combination Boiler</b></b-col>
                    <b-col align="right">Min Value {{this.RiskProfile.Tanks.CombiMin}}&deg;C</b-col></b-row>
                    <b-row><b-col align="left"><b>PoU Heaters</b></b-col>
                        <b-col align="left">Min Value {{this.RiskProfile.Tanks.POUMin}}&deg;C</b-col>
                        <b-col align="right">Max Value {{this.RiskProfile.Tanks.POUMax}}&deg;C</b-col> 
                    </b-row>
                    <b-row><b-col align="left"><b>Calorifier</b></b-col>
                        <b-col align="left">Out {{this.RiskProfile.Tanks.CalorifierOut}}&deg;C</b-col>
                        <b-col align="right">Return {{this.RiskProfile.Tanks.CalorifierReturn}}&deg;C</b-col> </b-row>
                
                </b-card>
                <b-card header="Cooling Towers" 
                    class="text-center"
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light"
                    v-if="CoolingVisible == true">
                    <b-row><b-col align="left"><b>System Temp</b></b-col>
                        <b-col align="right">Min Value {{this.RiskProfile.CoolingTowers.TowerTempMin}}&deg;C</b-col>
                        <b-col align="right" >Max Value {{this.RiskProfile.CoolingTowers.TowerTempMax}}&deg;C</b-col>
                    </b-row>
                    <b-row><b-col align="left" cols="5"><b>No Flow Threshold</b></b-col><b-col><b-badge pill variant="info"  
                        v-b-tooltip.hover title="Acceptable length of time for no flow events on cooling tower.">i</b-badge></b-col>
                    <b-col align="right">{{this.RiskProfile.CoolingTowers.TowerFlow}}hrs</b-col></b-row></b-card>
            </b-card-group>
            </b-col>
            </b-row>
            <b-row><b-col>
            <b-card-group deck>
                <b-card header="Other/Custom" 
                    class="text-center"
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light"
                    v-if="CustomVisible == true">
                    <b-row><b-col align="left" cols="3"><b>Custom Min Temp</b></b-col>
                        <b-col></b-col>
                        <b-col align="left">Min Value {{this.RiskProfile.Custom.CustomHot}}&deg;C</b-col></b-row>
                    <b-row><b-col align="left" cols="3"><b>Custom Max Temp</b></b-col>
                        <b-col></b-col>
                        <b-col align="left">Max Value {{this.RiskProfile.Custom.CustomCold}}&deg;C</b-col></b-row>
                    <b-row><b-col align="left" cols="3"><b>Custom Flow Frequency</b></b-col><b-col><b-badge pill variant="info"  
            v-b-tooltip.hover title="Acceptable length of time between recorded flow events on the outlet">i</b-badge></b-col>
  
                        <b-col align="left">{{this.RiskProfile.Custom.CustomFlow}}hrs</b-col></b-row>
                </b-card>
               
            </b-card-group>
            </b-col>
            </b-row>
            <br/>
            <b-button variant="outline-secondary" v-if="ActiveProfile == false"  v-on:click="showWizard('add')"><BIconPlusSquare /> Add</b-button>
            <b-button variant="outline-info" v-if="ActiveProfile == true"  v-on:click="showWizard('modify')">Edit</b-button>
            <br/>
            <br/>
        <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="SchemeWizard"
            id="SchemeWizard"
            title="Local Risk Control"
            hide-footer>
            <b-card> 
            <SOCWizard @WizardComplete="FinishWizard" :DataPass='PassedProfile' :Type='Type' :ID='SOCID' />
            </b-card>

        </b-modal>
      
    </div>
          
</template>
<script>
    import SOCWizard from "@/components/SOCComponents/SOCWizard.vue";
    import { BIconPlusSquare} from "bootstrap-vue/dist/bootstrap-vue.esm";
    import axios from "axios";

    export default {
        components: {
        SOCWizard,
        BIconPlusSquare,
    },
        data() {
            return {
                WizType: "",
                ActiveProfile: false,
                Type: null,
                selectedlocation: localStorage.getItem("CurrentLocation"),
                CurrentUser: localStorage.getItem("fullname"),
                PassedProfile:{
                    General: {
                        CreatedBy: "Angel Guard Default",
                        CreatedOn: "N/A",
                        Location: this.selectedlocation,
                        ResponsibleDept: "N/A",
                    },
                    HotWater: {
                        OutletMin: "50.00",
                        HotWaterReturn: "50.00"
                    },
                    ColdWater: {
                        OutletMax: "20.00",
                        SupplyTemp: "17.00"
                    },
                    Flow: {
                        OutletFrequency: "24"
                    },
                    TMV: {
                        TMVHot: "50.00",
                        TMVCold: "15.00",
                        MixedOut: "41.00"
                    },
                    Tanks: {
                        ColdWaterMax: "16.00",
                        HotWaterMin: "60.00",
                        HotWaterMax: "65.00",
                        CombiMin: "50.00",
                        POUMin: "50.00",
                        POUMax: "55.00",
                        CalorifierOut: "60.00",
                        CalorifierReturn: "50.00"
                    },
                    CoolingTowers: {
                        TowerTempMax: "25.00",
                        TowerTempMin: "05.00",
                        TowerFlow: "24"
                    },
                    Custom: {
                        CustomHot: "N/A",
                        CustomCold: "N/A",
                        CustomFlow: "N/A"
                    }

                },
                RiskProfile: {
                    General: {
                        CreatedBy: "",
                        CreatedOn: "",
                        Location: "",
                        ResponsibleDept: "",
                    },
                    HotWater: {
                        OutletMin: "",
                        HotWaterReturn: ""
                    },
                    ColdWater: {
                        OutletMax: "",
                        SupplyTemp: ""
                    },
                    Flow: {
                        OutletFrequency: ""
                    },
                    TMV: {
                        TMVHot: "",
                        TMVCold: "",
                        MixedOut: ""
                    },
                    Tanks: {
                        ColdWaterMax: "",
                        HotWaterMin: "",
                        HotWaterMax: "",
                        CombiMin: "",
                        POUMin: "",
                        POUMax: "",
                        CalorifierOut: "",
                        CalorifierReturn: ""
                    },
                    CoolingTowers: {
                        TowerTempMax: "",
                        TowerTempMin: "",
                        TowerFlow: ""
                    },
                    Custom: {
                        CustomHot: "",
                        CustomCold: "",
                        CustomFlow: ""
                    }
                },
                HotVisible: true,
                ColdVisible: true,
                FlowVisible: true,
                TMVVisible: true,
                TanksVisible: true,
                CoolingVisible: true,
                CustomVisible: false,
                SOCID: null,
                finishRequest: null,
                today: null
            }},
    computed: {},
    mounted(){

    let lookupURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/controlscheme";
    let lookupHeaders = this.$apikeyPost;
    let lookupRequest = {
      RequestType: "RetrieveSOC",
        DataDict: [
    {
      Location: this.selectedlocation
      
    }
                ]
    };

    axios.post(lookupURL, lookupRequest, lookupHeaders).then((response) => {
        let responseArray = response.data.Values

        if (responseArray.length == 0){
            this.ActiveProfile = false
            this.RiskProfile = this.PassedProfile
            this.Type = "New"
        } else{
            this.ActiveProfile = true
            this.SOCID = responseArray[0][0]
            this.RiskProfile.General.CreatedBy = responseArray[0][3]
            this.RiskProfile.General.CreatedOn = responseArray[0][2]
            this.RiskProfile.General.Location = this.selectedlocation
            this.RiskProfile.General.ResponsibleDept = responseArray[0][4]
            this.RiskProfile.HotWater.OutletMin = responseArray[0][8]
            this.RiskProfile.HotWater.HotWaterReturn = responseArray[0][9]
            this.RiskProfile.ColdWater.OutletMax = responseArray[0][10]
            this.RiskProfile.ColdWater.SupplyTemp = responseArray[0][11]
            this.RiskProfile.Flow.OutletFrequency = responseArray[0][12]
            this.RiskProfile.TMV.TMVHot = responseArray[0][13]
            this.RiskProfile.TMV.TMVCold = responseArray[0][14]
            this.RiskProfile.TMV.MixedOut = responseArray[0][15]
            this.RiskProfile.Tanks.ColdWaterMax = responseArray[0][16]
            this.RiskProfile.Tanks.HotWaterMin = responseArray[0][17]
            this.RiskProfile.Tanks.HotWaterMax = responseArray[0][18]
            this.RiskProfile.Tanks.CombiMin = responseArray[0][19]
            this.RiskProfile.Tanks.POUMin = responseArray[0][20]
            this.RiskProfile.Tanks.POUMax = responseArray[0][21]
            this.RiskProfile.Tanks.CalorifierOut = responseArray[0][22]
            this.RiskProfile.Tanks.CalorifierReturn = responseArray[0][23]
            this.RiskProfile.CoolingTowers.TowerTempMax = responseArray[0][24]
            this.RiskProfile.CoolingTowers.TowerTempMin = responseArray[0][25]
            this.RiskProfile.CoolingTowers.TowerFlow = responseArray[0][26]
            this.RiskProfile.Custom.CustomHot = responseArray[0][27]
            this.RiskProfile.Custom.CustomCold = responseArray[0][28]
            this.RiskProfile.Custom.CustomFlow = responseArray[0][29]

            if(this.RiskProfile.Custom.CustomHot == 0){
                this.CustomVisible = false} else{
            this.CustomVisible = true
                }

            this.Type="Modify"
        }
      

    });
    let current = new Date();
    this.today = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
        
    },

    methods:{
        showWizard(type){
            this.WizType = type
            if(this.WizType == 'modify'){
                this.PassedProfile = this.RiskProfile
            }
            else {
                this.PassedProfile
            }
            this.$refs["SchemeWizard"].show(this.WizType);
        },
        FinishWizard(ReturnedValues,returnedType,returnedID){
            this.$refs["SchemeWizard"].hide();


            this.finishRequest = null

            if (returnedType == 'Modify'){
                this.finishRequest =  {RequestType: "UpdateSOC",
                        DataDict: [
                            
                                {
      Location: this.selectedlocation,
      PassedValues: {
          General: {
              CreatedBy: ReturnedValues.General.CreatedBy,
              CreatedOn: this.today,
              Location: ReturnedValues.General.Location,
              ResponsibleDept: ReturnedValues.General.ResponsibleDept,
                    },
          HotWater: {
              OutletMin: ReturnedValues.HotWater.OutletMin,
              HotWaterReturn: ReturnedValues.HotWater.HotWaterReturn
                    },
          ColdWater: {
              OutletMax: ReturnedValues.ColdWater.OutletMax,
              SupplyTemp: ReturnedValues.ColdWater.SupplyTemp
                    },
          Flow: {
              OutletFrequency: ReturnedValues.Flow.OutletFrequency
                    },
          TMV: {
              TMVHot: ReturnedValues.TMV.TMVHot,
              TMVCold: ReturnedValues.TMV.TMVCold,
              MixedOut: ReturnedValues.TMV.MixedOut
                    },
          Tanks: {
              ColdWaterMax: ReturnedValues.Tanks.ColdWaterMax,
              HotWaterMin: ReturnedValues.Tanks.HotWaterMin,
              HotWaterMax: ReturnedValues.Tanks.HotWaterMax,
              CombiMin: ReturnedValues.Tanks.CombiMin,
              POUMin: ReturnedValues.Tanks.POUMin,
              POUMax: ReturnedValues.Tanks.POUMax,
              CalorifierOut: ReturnedValues.Tanks.CalorifierOut,
              CalorifierReturn: ReturnedValues.Tanks.CalorifierReturn
                    },
          CoolingTowers: {
              TowerTempMax: ReturnedValues.CoolingTowers.TowerTempMax,
              TowerTempMin: ReturnedValues.CoolingTowers.TowerTempMin,
              TowerFlow: ReturnedValues.CoolingTowers.TowerFlow
                    },
          Custom: {
              CustomHot: ReturnedValues.Custom.CustomHot,
              CustomCold: ReturnedValues.Custom.CustomCold,
              CustomFlow: ReturnedValues.Custom.CustomFlow
                    }
        
      },
                    SOCID: returnedID
    
                            }
                                ]}
  
            } else {
     
                
                this.finishRequest =  {RequestType: "InsertSOC",
                        DataDict: [
                            
                                {
      Location: this.selectedlocation,
      PassedValues: {
          General: {
              CreatedBy: ReturnedValues.General.CreatedBy,
              CreatedOn: this.today,
              Location: ReturnedValues.General.Location,
              ResponsibleDept: ReturnedValues.General.ResponsibleDept,
                    },
          HotWater: {
              OutletMin: ReturnedValues.HotWater.OutletMin,
              HotWaterReturn: ReturnedValues.HotWater.HotWaterReturn
                    },
          ColdWater: {
              OutletMax: ReturnedValues.ColdWater.OutletMax,
              SupplyTemp: ReturnedValues.ColdWater.SupplyTemp
                    },
          Flow: {
              OutletFrequency: ReturnedValues.Flow.OutletFrequency
                    },
          TMV: {
              TMVHot: ReturnedValues.TMV.TMVHot,
              TMVCold: ReturnedValues.TMV.TMVCold,
              MixedOut: ReturnedValues.TMV.MixedOut
                    },
          Tanks: {
              ColdWaterMax: ReturnedValues.Tanks.ColdWaterMax,
              HotWaterMin: ReturnedValues.Tanks.HotWaterMin,
              HotWaterMax: ReturnedValues.Tanks.HotWaterMax,
              CombiMin: ReturnedValues.Tanks.CombiMin,
              POUMin: ReturnedValues.Tanks.POUMin,
              POUMax: ReturnedValues.Tanks.POUMax,
              CalorifierOut: ReturnedValues.Tanks.CalorifierOut,
              CalorifierReturn: ReturnedValues.Tanks.CalorifierReturn
                    },
          CoolingTowers: {
              TowerTempMax: ReturnedValues.CoolingTowers.TowerTempMax,
              TowerTempMin: ReturnedValues.CoolingTowers.TowerTempMin,
              TowerFlow: ReturnedValues.CoolingTowers.TowerFlow
                    },
          Custom: {
              CustomHot: ReturnedValues.Custom.CustomHot,
              CustomCold: ReturnedValues.Custom.CustomCold,
              CustomFlow: ReturnedValues.Custom.CustomFlow
                    }
        
      },
                    SOCID: returnedID
    
                            }
                                ]}
  
                
  
            }
        
            let submitURL = "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
                this.$environment +
                "/controlscheme";
            let submitHeaders = this.$apikeyPost;
            let submitRequest = this.finishRequest;


            axios.post(submitURL, submitRequest, submitHeaders).then((response) => {
                response;
            
                this.updateVirtualLog("SchemeOfControl")
                this.refreshSOC();


        });
    },
    refreshSOC(){
        let lookupURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/controlscheme";
    let lookupHeaders = this.$apikeyPost;
    let lookupRequest = {
      RequestType: "RetrieveSOC",
        DataDict: [
    {
      Location: this.selectedlocation
      
    }
                ]
    };

    axios.post(lookupURL, lookupRequest, lookupHeaders).then((response) => {
        let responseArray = response.data.Values

        if (responseArray.length == 0){
            this.ActiveProfile = false
            this.RiskProfile = this.PassedProfile
            this.Type = "New"
        } else{
            this.ActiveProfile = true
            this.SOCID = responseArray[0][0]
            this.RiskProfile.General.CreatedBy = responseArray[0][3]
            this.RiskProfile.General.CreatedOn = responseArray[0][2]
            this.RiskProfile.General.Location = this.selectedlocation
            this.RiskProfile.General.ResponsibleDept = responseArray[0][4]
            this.RiskProfile.HotWater.OutletMin = responseArray[0][8]
            this.RiskProfile.HotWater.HotWaterReturn = responseArray[0][9]
            this.RiskProfile.ColdWater.OutletMax = responseArray[0][10]
            this.RiskProfile.ColdWater.SupplyTemp = responseArray[0][11]
            this.RiskProfile.Flow.OutletFrequency = responseArray[0][12]
            this.RiskProfile.TMV.TMVHot = responseArray[0][13]
            this.RiskProfile.TMV.TMVCold = responseArray[0][14]
            this.RiskProfile.TMV.MixedOut = responseArray[0][15]
            this.RiskProfile.Tanks.ColdWaterMax = responseArray[0][16]
            this.RiskProfile.Tanks.HotWaterMin = responseArray[0][17]
            this.RiskProfile.Tanks.HotWaterMax = responseArray[0][18]
            this.RiskProfile.Tanks.CombiMin = responseArray[0][19]
            this.RiskProfile.Tanks.POUMin = responseArray[0][20]
            this.RiskProfile.Tanks.POUMax = responseArray[0][21]
            this.RiskProfile.Tanks.CalorifierOut = responseArray[0][22]
            this.RiskProfile.Tanks.CalorifierReturn = responseArray[0][23]
            this.RiskProfile.CoolingTowers.TowerTempMax = responseArray[0][24]
            this.RiskProfile.CoolingTowers.TowerTempMin = responseArray[0][25]
            this.RiskProfile.CoolingTowers.TowerFlow = responseArray[0][26]
            this.RiskProfile.Custom.CustomHot = responseArray[0][27]
            this.RiskProfile.Custom.CustomCold = responseArray[0][28]
            this.RiskProfile.Custom.CustomFlow = responseArray[0][29]

            if(this.RiskProfile.Custom.CustomHot == 0){
                this.CustomVisible = false} else{
            this.CustomVisible = true
                }

            this.Type="Modify"
        }
      

    });


    },
   
    updateVirtualLog(action){
        // let current = new Date();
        // this.today = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
        let timestamp = new Date().toLocaleTimeString()
        if(action == "EscalationOnly"){
            let SubmitUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/notes";
      let SubmitHeaders = this.$apikeyPost;
      let SubmitLookUpRequest = {
        RequestType: "CreateVirtualLog",
        RequestVariable: "",
        DataDict: [
          {
            DeviceID:"",
            Location: this.selectedlocation ,
            NoteDate: this.today ,
            NoteTime: timestamp,
            NoteTrigger: 'Scheme of Control Update' ,
            NoteTitle: "Risk Profile Updated",
            NoteText: "The Escalation Details for the Risk Profile have been updated",
            UserName: this.CurrentUser
          }]
        };
      axios
        .post(SubmitUrl, SubmitLookUpRequest, SubmitHeaders)
        .then((response) => {
          response;

        });
        } else if (action == "SchemeOfControl"){
            let SubmitUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/notes";
      let SubmitHeaders = this.$apikeyPost;
      let SubmitLookUpRequest = {
        RequestType: "CreateVirtualLog",
        RequestVariable: "",
        DataDict: [
          {
            DeviceID:"",
            Location: this.selectedlocation ,
            NoteDate: this.today ,
            NoteTime: timestamp,
            NoteTrigger: 'Scheme of Control Update' ,
            NoteTitle: "Risk Profile Updated",
            NoteText: "The Risk Profile Scheme of Control has been updated",
            UserName: this.CurrentUser
          }]
        };
      axios
        .post(SubmitUrl, SubmitLookUpRequest, SubmitHeaders)
        .then((response) => {
          response;

        });
        }
    }
}

    }
</script>
        
<style>
        
</style>